const target = document.querySelector('.newsletter');

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            target.classList.add('active');
        }
    });
}, { threshold: 0.2 });  // triggers when 20% of the section is visible

observer.observe(target);






document.addEventListener('DOMContentLoaded', function () {

  const buttons = document.querySelectorAll('.change-view');
  const products = document.getElementById('product-grid');

  // ⛔ Stop if elements don't exist
  if (!buttons.length || !products) return;

  const viewClasses = ['grid-view', 'grid-2-view', 'list-view'];
  const STORAGE_KEY = 'productView';

  function applyView(view) {
    // Remove old view classes
    products.classList.remove(...viewClasses);

    // Remove active state from buttons
    buttons.forEach(btn => btn.classList.remove('change-view--active'));

    // Apply view class
    if (view === 'grid') {
      products.classList.add('grid-view');
    } else if (view === 'grid-2') {
      products.classList.add('grid-2-view');
    } else if (view === 'list') {
      products.classList.add('list-view');
    }

    // Safely add active class
    const activeBtn = document.querySelector(`.change-view[data-view="${view}"]`);
    if (activeBtn) {
      activeBtn.classList.add('change-view--active');
    }
  }

  // Load saved view
  const savedView = localStorage.getItem(STORAGE_KEY) || 'grid-2';
  applyView(savedView);

  // Click events
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const view = this.dataset.view;
      localStorage.setItem(STORAGE_KEY, view);
      applyView(view);
    });
  });

});




// document.querySelector('.page-join-the-collectors-club .overall_banners a.button')
//   .addEventListener('click', function (e) {
//     e.preventDefault();
//     document.querySelector('#collaborator_form').scrollIntoView({
//       behavior: 'smooth'
//     });
//   });
